/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

import {navigate} from '@/core/util/helper/navigation';

export const BUZZ_NOTIFICATION_TARGET_KEY = 'orangehrm.buzz.notificationTarget';

export type BuzzNotificationTarget = {
  shareId: number;
  commentId?: number | null;
};

export type BuzzNotificationItem = {
  share?: {id: number};
  comment?: {id: number};
};

export const storeBuzzNotificationTarget = (
  notification: BuzzNotificationItem,
): boolean => {
  const shareId = notification?.share?.id;
  if (!shareId) {
    return false;
  }

  const target: BuzzNotificationTarget = {
    shareId,
    commentId: notification?.comment?.id ?? null,
  };
  sessionStorage.setItem(BUZZ_NOTIFICATION_TARGET_KEY, JSON.stringify(target));
  return true;
};

export const consumeBuzzNotificationTarget =
  (): BuzzNotificationTarget | null => {
    const raw = sessionStorage.getItem(BUZZ_NOTIFICATION_TARGET_KEY);
    if (!raw) {
      return null;
    }

    sessionStorage.removeItem(BUZZ_NOTIFICATION_TARGET_KEY);
    try {
      const parsed = JSON.parse(raw) as BuzzNotificationTarget;
      if (!parsed?.shareId) {
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  };

export const navigateToBuzzNotification = (
  notification: BuzzNotificationItem,
): void => {
  if (!storeBuzzNotificationTarget(notification)) {
    return;
  }

  navigate('/buzz/viewBuzz');
};
